import style from "../css/DispenseCode.module.css";
import NavBar from "../../../commonComponent/Drawer/NavBar";
import Header from "../component/Header";
import banner from "../../../icons/utrIcons/How to Get UTR.webp";
import { ChevronRight } from "lucide-react";
import badge from "../../../icons/utrIcons/Vector.svg";
import { Link } from "react-router-dom";

function UTRInfo() {
  return (
    <div className={style.homeContainer}>
      <Header navText="PunnyaDhara" />

      <div className={style.navBarAlign}>
        <NavBar />
      </div>
      <img src={banner} alt="UTR Banner" className={style.bannerImage} />
      <div className={style.utrDetailBox} style={{ marginBottom: "10px" }}>
        <img src={badge} style={{ color: "#ED1967" }} />
        <Link
          to="https://wa.me/919821202888?text=hi"
          style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: "8px",
            flex: 1,
            textDecoration: "none",
          }}
        >
          <span
            style={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#ED1967",
            }}
          >
            Still Need help?
          </span>

          <span
            style={{
              fontWeight: "400",
              fontSize: "12px",
              color: "#000000",
            }}
          >
            Contact Support
          </span>
        </Link>
        <Link to="https://wa.me/919821202888?text=hi">
          <ChevronRight
            style={{
              color: "#D91A5E",
              marginRight: "10px",
            }}
            size={32}
          />
        </Link>
      </div>
    </div>
  );
}

export default UTRInfo;
